import React, { useState, useEffect } from 'react';
import { Stack, Title, Paper, Group, Select, TextInput, Button, Table, ActionIcon, Text, Textarea, NumberInput } from '@mantine/core';
import { IconTrash, IconEdit, IconCheck, IconX, IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

export default function AdminRentalTab({ apiBaseUrl }) {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({ name: '', description: '', category: '', pricePerDay: 0, currency: 'PLN', imageUrl: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const res = await axios.get(`${apiBaseUrl}/api/rentals`);
      setItems(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAdd = async () => {
    if (!newItem.name) return;
    setLoading(true);
    try {
      await axios.post(`${apiBaseUrl}/api/rentals`, newItem);
      setNewItem({ name: '', description: '', category: '', pricePerDay: 0, currency: 'PLN', imageUrl: '' });
      fetchItems();
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiBaseUrl}/api/rentals/${id}`);
      fetchItems();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Stack gap="xl">
      <Title order={2}>{t('rental_admin_title', 'Zarządzanie Wypożyczalnią')}</Title>
      
      <Paper p="md" withBorder shadow="sm" radius="md">
        <Title order={4} mb="md">{t('rental_add_new', 'Dodaj nowy sprzęt')}</Title>
        <Group align="flex-end" mb="md">
          <TextInput label={t('rental_name', 'Nazwa')} placeholder="np. Młot" value={newItem.name} onChange={e => setNewItem({...newItem, name: e.target.value})} style={{flex: 1}} />
          <TextInput label={t('rental_category', 'Kategoria')} placeholder="np. Budowa" value={newItem.category} onChange={e => setNewItem({...newItem, category: e.target.value})} />
          <NumberInput label={t('rental_price', 'Cena/doba')} value={newItem.pricePerDay} onChange={v => setNewItem({...newItem, pricePerDay: v})} />\n          <Select label={t('rental_currency', 'Waluta')} data={['PLN', 'USD', 'EUR', 'GBP', 'CHF']} value={newItem.currency} onChange={v => setNewItem({...newItem, currency: v})} />
        </Group>
        <TextInput label={t('rental_image', 'URL Obrazka')} placeholder="https://..." value={newItem.imageUrl} onChange={e => setNewItem({...newItem, imageUrl: e.target.value})} mb="md" />
        <Textarea label={t('rental_desc', 'Opis')} value={newItem.description} onChange={e => setNewItem({...newItem, description: e.target.value})} mb="md" />
        <Textarea label="Protokół odbioru - znane uszkodzenia (opcjonalnie)" placeholder="np. rysy, wady" value={newItem.conditionNotes || ''} onChange={e => setNewItem({...newItem, conditionNotes: e.target.value})} mb="md" />
        <Button leftSection={<IconPlus size={16} />} loading={loading} onClick={handleAdd}>{t('add_button', 'Dodaj')}</Button>
      </Paper>

      <Paper p="md" withBorder shadow="sm">
        <Table highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>ID</Table.Th>
              <Table.Th>{t('rental_name', 'Nazwa')}</Table.Th>
              <Table.Th>{t('rental_category', 'Kategoria')}</Table.Th>
              <Table.Th>{t('rental_price', 'Cena')}</Table.Th>
              <Table.Th>{t('rental_actions', 'Akcje')}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {items.map(item => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.id}</Table.Td>
                <Table.Td>{item.name}</Table.Td>
                <Table.Td>{item.category}</Table.Td>
                <Table.Td>{item.pricePerDay} {item.currency || 'PLN'}</Table.Td>
                <Table.Td>
                  <ActionIcon color="red" variant="subtle" onClick={() => handleDelete(item.id)}>
                    <IconTrash size={16} />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            ))}
            {items.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={5} style={{textAlign: 'center'}}>{t('no_items', 'Brak sprzętu')}</Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Paper>
    </Stack>
  );
}
